// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import styles from './HistoryCompressionCompletes.module.scss';
import { useEffect, useState } from 'react';
import { createAxios } from 'ts/createAxios';
import { LabelContents } from 'components/molecules/LabelContents';
import { CompressionCompleteData } from 'util/Types';
import { getFormatDateWithCurrentTimezone } from 'ts/formatDate';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from 'util/ConstantValues';
import { normalizeNumber } from 'util/commons';
import BigNumber from 'bignumber.js';

export type Props = {
  id?: string;
};

export const HistoryCompressionCompletes = () => {
  const commonsApi = createAxios();
  const { t } = useTranslation();
  const [compressionCompleteData, setCompressionCompleteData] = useState<
    CompressionCompleteData[]
  >([]);

  const callApi = async () => {
    const res = await commonsApi.get('/work-histories/compression/delivered');
    setCompressionCompleteData(res.data);
  };

  useEffect(() => {
    callApi();
  }, []);

  const calCulateTotalInputWeight = (data: CompressionCompleteData) => {
    const { total } = Object.values(data.byCompression).reduce(
      (res, it) => {
        if (!res.primaryProcessingIds.includes(it.primaryProcessingId)) {
          res.total = res.total.plus(it.totalInputWeight);
          res.primaryProcessingIds.push(it.primaryProcessingId);
        }

        return res;
      },
      {
        total: new BigNumber(0),
        primaryProcessingIds: [] as string[],
      }
    );

    return total;
  };

  return (
    <div className={styles.historyCompressionCompletes}>
      {compressionCompleteData &&
        compressionCompleteData.length > 0 &&
        compressionCompleteData.map((item, index) => {
          const totalInputWeight = calCulateTotalInputWeight(item);
          const leftWeight = totalInputWeight.minus(item.weight);

          return (
            <div className={styles.commonCard} key={index}>
              <LabelContents
                label={t('common_history_field.requested_date_time')}
                contents={getFormatDateWithCurrentTimezone(
                  item.requestedDatetime,
                  DATE_FORMAT.slaYMDHm
                )}
              />

              <LabelContents
                label={t('common_history_field.responsible_person')}
                contents={item.userId + '(' + item.userName + ')'}
              />

              <LabelContents
                label={t('common_history_field.shipping_address')}
                contents={item.deliveryToOperatorName}
              />

              <LabelContents
                label={t('common_history_field.material_name')}
                contents={item.description}
              />

              <LabelContents
                label={t('common.quality')}
                contents={item.grade}
              />

              <LabelContents
                label={`${t('pre_regist_resource_select.input_weight')} (kg)`}
                contents={normalizeNumber({
                  value: totalInputWeight,
                })}
              />

              <LabelContents
                label={`${t('common_history_field.weight')} (kg)`}
                contents={
                  <span>
                    {normalizeNumber({
                      value: item.weight,
                    })}
                    {leftWeight.toNumber() < 0 && (
                      <span
                        style={{
                          marginLeft: '8px',
                          color: '#ff2434',
                        }}
                      >
                        (
                        {t('common_history_field.exceeded_input_weight', {
                          value: normalizeNumber({
                            value: leftWeight.abs(),
                          }),
                        })}
                        )
                      </span>
                    )}
                  </span>
                }
              />

              <LabelContents
                label={t('common_history_field.registration_id')}
                contents={item.targetIds.join('\n')}
              />
            </div>
          );
        })}
    </div>
  );
};
